import { Modal, Button } from 'antd';
import React, { useEffect } from 'react';
import './index.less';

import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import actions from '../../../../action/index';
import { useTranslation } from 'react-i18next';
import Bingo from '@/assets/images/circle-bingo.svg';
import NoLimit from '@/assets/images/no_size_limit.svg';
import CurrentDevice from 'current-device';
import sentGAEvent from '@/ga';
import Cookies from 'js-cookie';
import Utils from '../../../../utils/utils';
import ThreeDayTrial, {
  getThreeDayTrialPlatform,
} from './threeDayTrial';
import { getPriceInfo } from '../config';

const PurchaseModal = ({ getPurchase, work, onPayBill, loading }) => {
  const { t } = useTranslation(['purchase']);

  const dispatch = useDispatch();
  const reducerData = useSelector((state) => state.common);
  const { purchaseModalObj } = reducerData;
  const [selectIndex, setSelectIndex] = useState(0);
  const [threeDayTrialChecked, setThreeDayTrialChecked] = useState(true);

  const [highLight, setHighLight] = useState(0);
  const [priceList, setPriceList] = useState([]);
  const showThreeDayTrial = Utils.getLanguage() === 'en';
  console.log('purchaseModalOBj', purchaseModalObj);
  const changeIndex = (index) => {
    setSelectIndex(index);
  };

  const onClose = () => {
    dispatch(actions.onPurchaseModalObjChange({ visible: false }));
  };

  const alreadySubscribe = () => {
    //onClose();
    dispatch(
      actions.onSignUpModal({
        visible: true,
      })
    );
  };
  useEffect(() => {
    switch (purchaseModalObj.type) {
      case 'uploadSizeBiggerThanLimit':
        setHighLight(0);
        break;
      case 'videoEditorTimesMoreThanLimit':
        setHighLight(1);
        break;
      default:
        setHighLight(-1);
    }
    if (purchaseModalObj.visible) {
      setThreeDayTrialChecked(true);
    }
  }, [purchaseModalObj]);

  useEffect(() => {
    if (!purchaseModalObj.visible) {
      return undefined;
    }

    let isMounted = true;

    getPriceInfo(Utils.getLanguage())
      .then(({ activePrice, priceList: serverPriceList }) => {
        if (!isMounted || serverPriceList.length === 0) {
          return;
        }

        setPriceList(serverPriceList);
        const activeIndex = serverPriceList.findIndex(
          (item) =>
            item === activePrice ||
            (item && activePrice && item.plan === activePrice.plan)
        );
        setSelectIndex(activeIndex > -1 ? activeIndex : 0);
      })
      .catch((error) => {
        console.error('Failed to get purchase price information:', error);
      });

    return () => {
      isMounted = false;
    };
  }, [purchaseModalObj.visible]);

  const goToPurchase = () => {
    if (
      work === 'removeWatermark' ||
      work === 'cut' ||
      work === 'addMusic' ||
      work === 'speed' ||
      work === 'reverse' ||
      work === 'addWatermark'
    ) {
      onPayBill({
        visible: true,
        type: priceList[selectIndex] && priceList[selectIndex].plan,
      });
    }
    sentGAEvent({
      category: 'Subscribe',
      action: 'SubscribePrompt_GotoPurchase_Click',
    });
    let currWork = localStorage.getItem('currGa');
    sentGAEvent({
      category: 'BuyClick',
      action: currWork + '_BuyClick',
    });
  };

  const list = [
    { content: t('vipTips1'), img: Bingo },
    { content: t('vipTips2'), img: Bingo },
    { content: t('vipTips3'), img: Bingo },
    { content: t('vipTips4'), img: Bingo },
  ];
  const warningList = [
    { content: t('fileSizeLimitTitle') },
    { content: t('freeTimesLimitTitle') },
  ];
  const selectedPrice = priceList[selectIndex];
  return (
    <div>
      <Modal
        destroyOnClose
        className={`${CurrentDevice.mobile()
            ? 'purchaseMobileExceed20M'
            : 'purchaseExceed20M'
          }`}
        footer={null}
        maskClosable={false}
        centered
        visible={purchaseModalObj.visible}
        //visible={true}
        onCancel={() => onClose()}
      >
        <div className='purchaseContainer'>
          <div className='leftContainer'></div>
          <div className='rightContainer'>
            {highLight != -1 ? (
              <div className='tips'>
                <span className='warning'>!</span>
                {warningList[highLight].content}
              </div>
            ) : (
              <></>
            )}
            <div className='title'>
              {t('common:HitPawTitle')} <span className='pro'>Pro</span>
            </div>
            <div className='listData'>
              {list.map((item, index) => {
                return (
                  <div
                    key={'highLight' + index}
                    className={`list ${highLight === index ? 'highLight' : ''}`}
                  >
                    <img
                      alt=''
                      src={highLight === index ? NoLimit : item.img}
                    />{' '}
                    {item.content}
                  </div>
                );
              })}
            </div>
            <div className='3-day-trial-area'>
              {showThreeDayTrial ? (
                <ThreeDayTrial
                  checked={threeDayTrialChecked}
                  onChange={setThreeDayTrialChecked}
                />
              ) : (
                ''
              )}
            </div>
            <div
              className={`priceCard ${
                showThreeDayTrial ? 'withThreeDayTrial' : ''
              }`}
            >
              {priceList.map((item, index) => {
                return (
                  <div
                    key={'purchase' + index}
                    className={`card ${selectIndex === index ? 'selected' : ''
                      }`}
                    onClick={() => changeIndex(index)}
                  >
                    <div className='cardContainer'>
                      <div className='plan'>{item.label || item.plan}</div>
                      <div className='priceContainer'>
                        <span className='price'>{item.dayPrice}</span>
                        <span className='time'>/{t('day')}</span>
                      </div>
                    </div>
                    {item.discountPrice ? (
                      <div className='totalPrice'>{item.discountPrice}</div>
                    ) : (
                      ''
                    )}
                  </div>
                );
              })}
            </div>
            <div className='btnGroup'>
              <Button
                loading={loading}
                disabled={!selectedPrice}
                className='buyNow'
                onClick={() => {
                  if (!selectedPrice || !selectedPrice.plan) {
                    return;
                  }

                  getPurchase(selectedPrice.plan, {
                    threeDayTrialChecked:
                      showThreeDayTrial && threeDayTrialChecked,
                    threeDayTrialPlatform: getThreeDayTrialPlatform(),
                  });
                  goToPurchase();
                }}
              >
                {t('common:BUY NOW')}
              </Button>
              {!Cookies.get('authorization') ? (
                <div onClick={() => alreadySubscribe()} className='subBtn'>
                  {t('AlreadySubscribe')}
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default PurchaseModal;
